export default "49452612759dc240.svg"